<template>
  <div
    id="tableHeight"
    class="flex-v flex_align"
    :style="{
      height: Number(wdclientHeight) + (!checkPagination ? 40 : 0) + 'px',
    }"
  >
    <!-- :style="{maxHeight:screenHeight+'px',minHeight:screenHeight+'px',height:screenHeight+'px'}" -->
    <el-table
      ref="Table"
      class="table-container"
      v-loading="options.loading"
      :data="dataSource"
      :max-height="options.maxHeight"
      :stripe="options.stripe"
      :id="id"
      :border="options.border"
      @row-click="handleRowClick"
      @selection-change="handleSelectionChange"
      header-row-class-name="table-header-row"
      :header-cell-style="{ background: '#409EFF', color: '#fff' }"
      :height="screenHeight"
      :row-class-name="tableRowClassName"
      @sort-change="sortChange"
      :row-key="options.key"
      :cell-style="cellStyle"
      @current-change="handleCurrentChange"
      highlight-current-row
      @row-dblclick="handleDblclick"
      @cell-click="handleCellClick"
      :summary-method="getSummaries"
      :show-summary="options.showSummary"
      v-if="reFresh"
    >
      <!--selection选择框-->
      <el-table-column
        v-if="options.mutiSelect"
        type="selection"
        style="width: 50px"
        align="center"
        :reserve-selection="options.reserve"
        :selectable="selectable"
        fixed="left"
      ></el-table-column>
      <!-- 单选 -->
      <el-table-column
        v-if="options.mutiRadio"
        style="width: 50px"
        align="center"
        :selectable="selectable"
        :reserve-selection="options.reserve"
        fixed="left"
      >
        <template slot-scope="scope">
          <el-radio
            v-model="radioVal"
            @change.native="getRow(scope.row)"
            :label="scope.$index"
            >&nbsp;</el-radio
          >
        </template>
      </el-table-column>
      <!--序号-->
      <el-table-column
        v-if="options.index"
        label="序号"
        type="index"
        :width="options.showSummary ? '100px' : '50px'"
        align="center"
        fixed="left"
        :resizable="false"
      ></el-table-column>

      <!--数据列 -->
      <el-table-column
        :key="index"
        v-for="(column, index) in columns"
        :prop="column.prop"
        :label="column.label"
        :width="column.dateFormat ? '150px' : column.width"
        :align="column.align || 'center'"
        :fixed="column.fixed"
        class="table-box"
        :sortable="column.custom"
        :sort-orders="['ascending', 'descending']"
        :render-header="column.required"
        show-overflow-tooltip
        :resizable="false"
      >
        <template slot-scope="scope">
          <template v-if="!column.render">
            <!-- 增加颜色圆圈 -->
            <template v-if="column.statusShow">
              <span
                class="statusred"
                v-if="formatterBtn(column.statusShow, scope.row, scope.$index)"
              ></span>
            </template>
            <!-- 增加绿色圆圈 -->
            <template v-else-if="column.statusShowGreen">
              <span
                class="statusgreen"
                v-if="formatterBtn(column.statusShow, scope.row, scope.$index)"
              ></span>
            </template>

            <!-- 增加处方特管药标识 -->
            <template v-else-if="column.RxStatus">
              <span
                class="statusredRx"
                v-if="formatterBtn(column.RxStatus, scope.row, scope.$index)"
                >Rx</span
              >
            </template>
            <!-- 增加雪花? -->
            <template v-else-if="column.isRefrigerate">
              <span
                class="refrigerate"
                v-if="
                  formatterBtn(column.isRefrigerate, scope.row, scope.$index)
                "
              >
                <el-tooltip content="冷藏药品" placement="top">
                  <i aria-hidden="true" class="fa fa-snowflake-o"></i>
                </el-tooltip>
              </span>
            </template>
            <!-- 时间截断时分秒-->
            <template v-else-if="column.dateFormatYYMMDD">
              <span
                :class="colClassName(column.className, scope.row, scope.$index)"
              >
                {{
                  dateFormatYYMMDD(
                    scope.row[column.prop],
                    column.dateFormatYYMMDD
                  )
                }}
              </span>
            </template>
            <!-- 表格里面嵌入方法 -->
            <template v-else-if="column.formatter">
              <span
                :class="colClassName(column.className, scope.row, scope.$index)"
              >
                {{
                  format(column.formatter, scope.row, scope.$index, column.prop)
                }}
              </span>
            </template>
            <!-- 表格里面嵌入方法 -->
            <template v-else-if="column.ToFixed">
              <template>
                <span>{{ Tofixeds(scope.row[column.prop]) }}</span>
              </template>
            </template>
            <!-- 获取对象里面的值 -->
            <template v-else-if="column.parent">
              <!-- <span
                v-if="column.dateFormatYYMMDD"
                :class="colClassName(column.className,scope.row, scope.$index)"
              >{{dateFormatYYMMDD(scope.row[column.prop],column.dateFormatYYMMDD)}}</span>-->
              <span
                :class="colClassName(column.className, scope.row, scope.$index)"
                >{{ scope.row[column.parent][column.prop] }}</span
              >
            </template>
            <!-- 集合拼接 -->
            <template v-else-if="column.list">
              <template v-for="(item, index) in column.list">
                {{ scope.row[item] }}
                <span v-if="index != column.list.length - 1">/</span>
              </template>
            </template>

            <!-- 是否增加标签 -->
            <template v-else-if="column.tagShow">
              <span
                v-if="formatterBtn(column.tagShow, scope.row, scope.$index)"
              >
                {{ scope.row[column.prop] }}
                <el-tag size="mini" :type="column.tag.type">{{
                  column.tag.content
                }}</el-tag>
              </span>
              <span v-else>{{ scope.row[column.prop] }}</span>
            </template>
            <template v-else-if="column.colors">
              <span style="color: red" v-if="scope.row[column.prop] <= 0">{{
                scope.row[column.prop]
              }}</span>
              <span style="color: green" v-if="scope.row[column.prop] > 0">{{
                scope.row[column.prop]
              }}</span>
            </template>
            <template v-else-if="column.firstRemark">
              <span v-if="scope.row.inventoryPhase == 2">{{
                scope.row[column.prop]
              }}</span>
            </template>
            <!-- 输入框 -->
            <template v-else-if="column.input">
              <el-input
                :id="'tableDetail' + scope.$index + '1'"
                @keyup.native="TablekeyUp($event, scope.$index, 'tableDetail')"
                @input="
                  changeVal(scope.row, scope.$index, scope.row[column.prop])
                "
                type="text"
                @click.stop.native="
                  changeVal(scope.row, scope.$index, scope.row[column.prop])
                "
                v-model="scope.row[column.prop]"
                maxlength="10"
                :disabled="column.disabled || scope.row.isEnter == 1"
                style="width: 120px"
              ></el-input>
            </template>
            <template v-else>
              <span
                :class="colClassName(column.className, scope.row, scope.$index)"
                >{{ scope.row[column.prop] }}</span
              >
            </template>
          </template>

          <template v-else>
            <RenderDom
              :row="scope.row"
              :index="index"
              :render="column.render"
            />
          </template>

          <!-- 操作栏按钮 -->
          <template v-if="column.button">
            <template v-if="column.btns">
              <el-button
                size="mini"
                type="text"
                v-if="column.btns && scope.row.enterDetailId != null"
                @click.stop.native="changeNumber(scope.row)"
                >{{ scope.row.isEnter == 1 ? "修改" : "保存" }}</el-button
              >
            </template>
            <template v-for="(btn, i) in column.group" v-if="!column.prop">
              <el-button
                :style="btn.style"
                :key="i"
                :type="btn.type"
                :size="btn.size || 'mini'"
                :icon="btn.icon"
                :disabled="btn.disabled"
                :plain="btn.plain"
                :sortable="column.custom"
                :sort-orders="['ascending', 'descending']"
                @click.stop="btn.onClick(scope.row, scope.$index)"
                v-if="
                  formatterBtn(btn.formatter, scope.row, scope.$index) &&
                  btnAuthority(btn.authority) &&
                  !btn.popover
                "
              >
                <!-- 用来设置表格字段也可以使用方法 -->
                <template v-if="btn.prop">{{ scope.row[btn.prop] }}</template>
                <template v-else>{{ btn.name }}</template>
              </el-button>

              <template v-else-if="btn.popover">
                <el-popover
                  placement="right"
                  trigger="click"
                  :key="i"
                  width="110"
                >
                  <template v-for="(el, dex) in btn.group">
                    <el-button
                      :key="dex"
                      :type="el.type"
                      :style="el.style"
                      :size="el.size || 'mini'"
                      :plain="el.plain"
                      @click.stop="el.onClick(scope.row, scope.$index)"
                    >
                      <template>{{ el.name }}</template>
                    </el-button>
                  </template>

                  <el-button slot="reference" class="reference">{{
                    btn.name
                  }}</el-button>
                </el-popover>
              </template>
            </template>

            <!-- 非操作栏按钮 -->
            <template v-for="(btn, i) in column.group" v-else>
              <el-button
                :style="btn.style"
                :key="i"
                :type="btn.type"
                :size="btn.size || 'mini'"
                :icon="btn.icon"
                :disabled="btn.disabled"
                :plain="btn.plain"
                @click.stop="btn.onClick(scope.row, scope.$index)"
                v-if="
                  formatterBtn(btn.checkButtonShow, scope.row, scope.$index)
                "
              >
                <!-- 用来设置表格字段也可以使用方法 -->
                <template v-if="btn.name">{{ btn.name }}</template>
                <template v-else>{{ scope.row[column.prop] }}</template>
              </el-button>
            </template>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="!checkPagination"
      :total="pagination.total"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleIndexChange"
      class="paginations"
      :current-page="pagination.pageIndex"
    ></el-pagination>
  </div>
</template>

<script>
import StringUtil from "../../utils/StringUtil.js";
import MGridUtil from "../../utils/MGridUtil.js";
export default {
  components: {
    RenderDom: {
      functional: true, // 函数式组件 - 无 data 和 this 上下文 => better render
      props: {
        row: Object,
        index: Number,
        render: Function,
      },
      /**
       * @param {Function} createElement - 原生创建dom元素的方法， 弃用，推荐使用 jsx
       * @param {Object} ctx - 渲染的节点的this对象
       * @argument 传递参数 row index
       */
      render(createElement, ctx) {
        const { row, index } = ctx.props;
        return ctx.props.render(row, index);
      },
    },
  },
  props: {
    options: Object, // 表格参数控制 maxHeight、stripe 等等...
    columns: Array,
    fetch: Function, // 获取数据的函数
    id: String,
    checkPagination: Boolean, // 是否隐藏分页
    tableRowClassName: Function, // 用于设置行的颜色
    selectable: Function, //用于设置禁选列表行
    cellStyle: Function, //设置表格单列变色
    height: String, //表格高度
    getSummaries: Function,
  },
  created() {
    // 传入的options覆盖默认设置
    this.$parent.options = Object.assign(
      {
        // maxHeight: 500,
        stripe: true, // 是否为斑马纹
        border: true,
      },
      this.options
    );
  },
  data() {
    return {
      dataSource: [],
      pagination: {
        // 分页参数
        isPagina: true, // 是否分页
        total: 0,
        pageIndex: this.options.Tindex ? this.options.Tindex : 1,
        pageSize: this.options.Tsize ? this.options.Tsize : 20,
      },
      screenHeight: this.getHeight(), //屏幕高度 this.getHeight()
      wdclientHeight: this.getHeight(),
      radioVal: -1,
      boolean: false, //全选  分页勾选
      reFresh: true,
    };
  },
  mounted() {
    let that = this,
      resizeTimer = null;
    this.options.initTable && this.fetch();
    if (this.options.showSummary || this.options.clientHeight) {
      that.calcHeight();
      $(window).bind("resize", function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          that.wdclientHeight = that.getHeight();
          that.screenHeight = that.getHeight();
        }, 100);
      });
    } else if (this.options.isDailogHeight) {
      this.screenHeight = that.getHeight();
      $(window).bind("resize", function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          // console.log("窗口发生改变了！");
          that.screenHeight = document.documentElement.clientHeight * 0.42;
        }, 100);
      });
    }
  },
  methods: {
    //计算高度
    calcHeight() {
      let _this = this,
        resizeTimer = null,
        wapper = document.getElementsByClassName("el-table__body-wrapper"),
        header = document.getElementsByClassName("el-table__header-wrapper");
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (_this.options.showSummary) {
          // _this.screenHeight = _this.wdclientHeight - 1;
          wapper[0].style.height =
            _this.wdclientHeight - header[0].clientHeight - 31 + "px";
        } else {
          wapper[0].style.height =
            _this.wdclientHeight - header[0].clientHeight + "px";
        }
      }, 100);
    },
    getHeight() {
      if (this.options.clientHeight || this.options.showSummary) {
        return (
          document.documentElement.clientHeight -
          this.options.table_top_height -
          (this.options.pagination_height || 0)
        );
      } else if (this.options.minHeight) {
        return "350";
      } else if (this.options.isDailogHeight) {
        return document.documentElement.clientHeight * 0.42;
      } else if (this.options.maxHeight) {
        return this.options.maxHeight;
      } else {
        return "550";
      }
    },
    handleSizeChange(size) {
      // 切换每页显示的数量
      this.options.Tsize = size;
      this.pagination.pageSize = size;
      this.fetch();
      // this.$nextTick(function() {
      //   if (this.boolean) {
      //     this.toggleSelection(this.boolean);
      //   }
      // });
    },
    handleIndexChange(current) {
      // 切换页码
      this.options.Tindex = current;
      this.pagination.pageIndex = current;
      this.fetch();
      // this.$nextTick(function() {
      //   if (this.boolean) {
      //     this.toggleSelection(this.boolean);
      //   }
      // });
    },
    //
    changeNumber(row) {
      if (row.isEnter == 1) {
        row.isEnter = 0;
      } else {
        this.$emit("CheckDetailId", row);
      }
    },
    handleCurrentChange(currentRow, oldCurrentRow) {
      this.$emit("current-change", currentRow, oldCurrentRow);
    },
    handleDblclick(row, $event) {
      this.$emit("row-dblclick");
    },
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    handleRowClick(row, $event, column, cell) {
      this.$emit("row-click", row, event, column, cell);
    },
    handleCellClick(row, column, cell, event) {
      this.$emit("cell-click", row, column, cell, event);
    },
    sortChange(column, prop, order) {
      this.$emit("sortChange", column, prop, order);
    },
    // getSummaries(param) {
    //   this.$emit("summary-method", param);
    // },
    //时间格式化
    dateFormat(time, type) {
      return MGridUtil.getTime(type, time);
    },
    //时间截断
    dateFormatYYMMDD(time, type) {
      return MGridUtil.dateFormatYYMMDD(type, time);
    },
    /**
     *@method:toggleSelection
     *@description:分页全选
     **/
    toggleSelection(bool) {
      this.boolean = bool;
      if (bool) {
        this.$refs.Table.clearSelection();
        // this.dataSource = res.rows; //重新赋值
        this.dataSource.forEach((row) => {
          this.$refs.Table.toggleRowSelection(row);
        });
      } else {
        this.boolean = false;
        this.$refs.Table.clearSelection();
      }
    },
    /**
     *@method:setCurrentRow
     *@description:单选表格 设定某一行为选中行
     **/
    setCurrentRow(row) {
      if (row) {
        this.$refs.Table.setCurrentRow(row);
      }
    },
    /**
     * 删除
     * id
     * selectionList   选中的列表
     * idName 名称
     * url    删除接口名
     * functionName 回调函数名
     * parem 回调函数传的值
     */
    del(id, selectionList, idName, url, functionName, parem) {
      var _this = this;
      // 判断id是否存在
      if (id == undefined) {
        // 筛选出id
        id = StringUtil.commaTransition(selectionList, idName);
      }
      if (id != "") {
        this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.request("Get", url + id, {}, true).then((response) => {
              // 判断表格里面是否为最后一个参数
              if (
                _this.dataSource.length == 1 &&
                _this.pagination.pageIndex != 1
              ) {
                _this.pagination.pageIndex -= 1;
              }
              if (functionName != null) {
                _this.$emit(functionName, parem);
              }
              _this.fetch();
              // 清空删除了的数据
              selectionList = [];
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "请选择需要删除的数据",
        });
      }
    },
    /**
     *     格式化表格内容
     *     fn 方法
     *     row 数据对象
     *  propName 参数名称
     */
    format(fn, row, index, propName) {
      fn(row, index);
      return row[propName];
    },
    //键盘监听
    TablekeyUp(ev, index, str) {
      let that = this;
      let id = ev.target.id;
      let max = id.indexOf("tableDetail") > -1 ? this.dataSource.length : [];
      let left = Number(id.substr(id.length - 1, 1));
      if (ev.keyCode == 37) {
        if (left == 2) {
          document.querySelector("#" + str + index + "1").focus();
        }
      }
      if (ev.keyCode == 38) {
        if (index != 0) {
          index--;
          document.querySelector("#" + str + index + left).focus();
        }
      }
      if (ev.keyCode == 39) {
        if (left == 1) {
          document.querySelector("#" + str + index + "2").focus();
        }
      }
      if (ev.keyCode == 40) {
        if (index < max - 1) {
          index++;
          document.querySelector("#" + str + index + left).focus();
        }
      }
      if (ev.keyCode == 13) {
        that.$emit("row-click", that.dataSource[index]);
        if (index < max - 1) {
          index++;
          document.querySelector("#" + str + index + left).focus();
        }
        // that.handleSelectionChange(this.dataSource[index])
      }
    },
    /**
     *  控制按钮是否显示
     */
    formatterBtn(fn, row, index) {
      // 如果方法为空直接返回
      if (fn == undefined) {
        return true;
      } else {
        var status = {
          show: false,
        };
        fn(row, index, status);
        return status.show;
      }
    },
    //输入框出发
    changeVal(row, index, val) {},
    /**
     *  控制列的显示颜色
     */
    colClassName(fn, row, index) {
      // 如果方法为空直接返回
      if (fn == undefined) {
        return "";
      } else {
        var status = {
          className: "",
        };
        fn(row, index, status);
        return status.className;
      }
    },
    Tofixeds(value) {
      if (!!value) {
        return this.MGridUtil.toFixedTwo(value);
      }
    },
    /**
     *  按钮权限
     */
    btnAuthority(value) {
      if (value == undefined) {
        return true;
      } else {
        return this.authorityUtil.checkAuthority(value);
      }
    },
    /**
     * 列表查询
     * urL 访问路径
     * obj 参数
     * method    赋值后执行的方法
     */
    searchData(url, obj) {
      this.pagination.pageIndex = 1;
      this.pagination.pageSize = 20;
      return this.showList(url, obj);
    },
    showList(url, obj) {
      if (this.options.isLoadings != undefined && !this.options.isLoadings) {
        this.options.loading = false;
      } else {
        this.options.loading = true;
      }
      // this.options.loading = true;
      if (this.options.Tindex) {
        this.pagination.Tindex = this.options.Tindex;
      }
      if (this.options.Tsize) {
        this.pagination.pageSize = this.options.Tsize;
      }
      // console.log(this.pagination.pageSize);
      // console.log(this.pagination.pageIndex);
      // this.pagination.pageIndex = 1;
      // this.pagination.pageSize = 20;
      obj.limit = this.pagination.pageSize;
      obj.offset = (this.pagination.pageIndex - 1) * this.pagination.pageSize;
      return new Promise((resolve, reject) => {
        this.request("Post", url, obj, false, false)
          .then((response) => {
            this.dataSource = response.rows;
            this.pagination.total = response.total;
            this.options.loading = false;
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    //不发请求直接传入数据
    showData(obj, total) {
      if (obj.length != 0) {
        this.options.loading = true;
      }
      this.dataSource = obj;
      this.pagination.isPagina = false;
      this.pagination.total = total;
      this.options.loading = false;
    },
    //初始化分页值
    initPage() {
      this.pagination = {
        // 分页参数
        isPagina: true, // 是否分页
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      };
    },
    getRow(row) {
      this.$emit("getTableRowData", row);
    },
    getRowKeys(row) {
      return row.suId;
    },
  },
  watch: {
    /**
     * @param {Boolean} 合计表格 数据更新重绘
     */
    dataSource() {
      if (this.options.showSummary) {
        this.reFresh = false;
        this.$nextTick(() => {
          this.reFresh = true;
        });
      }
    },
  },
};
</script>

<style>
/* #tableHeight {
  display: flex;
  flex-direction: column;
  align-items: center;
} */
.h100 {
  height: 100%;
}
.el-table__footer-wrapper {
  height: 31px;
}
.el-table__footer {
  height: 100%;
}
.el-table th.gutter {
  display: table-cell !important;
}
/* .el-table .warning-row {
  color: #f56c6c;
}
.el-table .err-row {
  color: red;
}
.el-table .slight-warning {
  color: #ffcc00;
} */
.el-table .warning {
  color: #dcdfe6;
  cursor: no-drop;
}
.el-table .grey {
  /* color: #f56c6c; */
  background-color: #e4e4e4;
}
.el-table .grey-row {
  background-color: #f2f2f2;
}
.el-table .grey-row td:last-child {
  background-color: #fff;
}
.el-table .grey-row-font {
  color: #cccccc;
}
.reference {
  color: #61a7cf;
  background: 0 0;
  padding-left: 0;
  padding-right: 0;
  border: 0;
  margin-left: 20px;
  margin-right: 40px;
  font-size: 12px;
  outline: none;
  font-weight: bold;
}
.statusgreen {
  margin-right: 3px;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: green;
}
.statusred {
  margin-right: 3px;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: red;
}
.statusredRx {
  display: inline-block;
  width: 20px;
  height: 16px;
  line-height: 16px;
  border-radius: 50%;
  background: red;
  color: #fff;
}
.success-row {
  color: #00cc00;
}
.success-row-1 {
  color: #76b828;
}
.warning-row {
  color: #ff0000;
}
.primary-row {
  color: #61a7cf;
}
</style>



// WEBPACK FOOTER //
// src/components/MGrid/table.vue